<template>
  <nav v-if="totalPages > 1" class="list-pager" aria-label="Пагинация">
    <button
      type="button"
      class="btn btn-secondary btn-sm list-pager-btn"
      aria-label="Предыдущая страница"
      :disabled="disabled || page <= 1"
      @click="$emit('update:page', page - 1)"
    >
      ‹
    </button>
    <span class="list-pager-label">{{ page }} / {{ totalPages }}</span>
    <button
      type="button"
      class="btn btn-secondary btn-sm list-pager-btn"
      aria-label="Следующая страница"
      :disabled="disabled || page >= totalPages"
      @click="$emit('update:page', page + 1)"
    >
      ›
    </button>
  </nav>
</template>

<script setup>
defineProps({
  page: {
    type: Number,
    required: true,
  },
  totalPages: {
    type: Number,
    default: 0,
  },
  total: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['update:page'])
</script>

<style scoped>
.list-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 0.375rem;
  margin-top: 0.5rem;
  flex-shrink: 0;
}

.list-pager-label {
  font-size: 0.75rem;
  color: #64748b;
  white-space: nowrap;
  min-width: 2.5rem;
  text-align: center;
}

.list-pager-btn {
  min-width: unset;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  font-size: 1rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
